module.exports = __webpack_public_path__ + "static/media/square.bbcca7f0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/square.jpeg
// module id = 298
// module chunks = 0